import { useSelector } from "react-redux"
import AboutMainCampus from "../components/campusLife/aboutMainCampus"
import Colleges from "../components/campusLife/colleges"
import Location from "../components/campusLife/location"
import TakeATour from "../components/campusLife/takeATour"
import TravelingCard from "../components/campusLife/travelingCard"
import { routes } from "../routes"


const AboutPutrajayaCampus = () => {
   const state = useSelector(state => state.campusLifeTab)
    const campusLife = state?.data?.properties
    const description = campusLife?.subHeader
    const path = campusLife?.introductionVideoURL
    return (
        <>
            <div className="flex flex-col gap-16 md:px-10">
                <TakeATour description={description} videoPath={path} />
                <AboutMainCampus campusData={campusLife} />
                <Colleges/>
                <Location campusData={campusLife}/>
                <TravelingCard travelingCards={campusLife?.transportationMode?.items} btnText="Discover KSHAS Campus" btnLink={routes.campusLife.kshasCampus} />
                
            </div>
        </>
    )
}

export default AboutPutrajayaCampus